import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import Header from "components/Header/Header";
import ImageViewer from "components/ImageViewer/ImageViewer";
import useCart from "hooks/useCart";
import Button from "components/Button/Button";
import spinner from "assets/icons/spiner.gif";
import OrderFeedback from "containers/VendingMachineDispense/OrderFeedack/OrderFeedback";
import { APP_ROUTES } from "constants/routes";
import { requestPostFetchApi } from "utils/apiMethods";
import { API_KEYS } from "constants/apiEndpoints";
import { convertSecondsToMilliseconds } from "utils/commonMethods";
import { CrossIcon, SuccessIcon } from "constants/icons";
import "containers/VendingMachineDispense/VendingMachineDispense.css";
import { getUserHashToken, getUserPhone } from "utils/commonMethods";
import useAuthentication from "hooks/useAuthentication";
import { resetVmStock } from "store/actions/vmStock.action";
function VendingMachineDispense({
  match: { params },
  history,
  location,
  clDetails,
}) {
  const DISPENSE_WAITING = null,
    DISPENSE_FAILURE = 0,
    DISPENSE_SUCCESS = 1,
    API_POLLING_INTERVAL = 2000; //in milliseconds;
  const componentTexts = window.appTexts.dispense_page;
  const cUID = params.cartId;
  const orderId = params.orderId;
  const { getUserId } = useAuthentication();

  //State management.
  const vendingMachineDetails = useSelector((state) => state.vmDetailsReducer);
  const { currentCartItems, clearCart } = useCart();
  const [errorOccured, setErrorOccured] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [dispenseProducts] = useState(currentCartItems);
  const dispatch = useDispatch();

  //Handles dispense status of each product.
  const [productsDispenseStatuses, setProductDispenseStatuses] = useState(
    dispenseProducts.reduce((accumulator, element) => {
      accumulator[element.item.sid] = DISPENSE_WAITING;
      return accumulator;
    }, {})
  );
  const [vendDispenseCompleted, setVendStatusCompleted] = useState(false);

  //Controllers
  const goToDashboard = function () {
    dispatch(resetVmStock());
    return history.push(APP_ROUTES.HOME_PAGE.url);
  };

  //Fails dispensing
  const dispenseFailed = function () {
    let nextProductDispenseStatuses = {};

    Object.keys(productsDispenseStatuses).forEach(
      (element) => (nextProductDispenseStatuses[element] = DISPENSE_FAILURE)
    );

    //Fail all the items.
    setProductDispenseStatuses(nextProductDispenseStatuses);
    setVendStatusCompleted(true);
    return setErrorOccured(true);
  };

  //Calls product status api in intervals.
  const startProductStatusPolling = function (dispenseTimeout) {
    //If current time exceeds dispense timeout, fail the dispensing.
    if (new Date().getTime() >= dispenseTimeout) {
      return dispenseFailed();
    }

    requestPostFetchApi(API_KEYS.GET_VENDING_STATUS_OF_PRODUCTS, {
      order_id: orderId,
      phone_no: getUserPhone(),
      hash: getUserHashToken(),
    }).then((response) => {
      //Waiting for final status
      if (response.vend_status === DISPENSE_WAITING) {
        let nextProductDispenseStatuses = {};

        response.CartDetails.forEach(
          (element) =>
            (nextProductDispenseStatuses[element.sid] = element.vend_status)
        );
        //Set new vend status of each product.
        setProductDispenseStatuses(nextProductDispenseStatuses);
        return setTimeout(() => {
          startProductStatusPolling(dispenseTimeout);
        }, API_POLLING_INTERVAL);
      } else if (response.vend_status === DISPENSE_SUCCESS) {
        let nextProductDispenseStatuses = {};

        Object.keys(productsDispenseStatuses).forEach(
          (element) => (nextProductDispenseStatuses[element] = DISPENSE_SUCCESS)
        );
        setVendStatusCompleted(true);
        //set vend status of all products to success.
        setProductDispenseStatuses(nextProductDispenseStatuses);
        return setVendStatusCompleted(true);
      } else {
        let nextProductDispenseStatuses = {};

        response.CartDetails.forEach(
          (element) =>
            (nextProductDispenseStatuses[element.id] =
              element.vend_status || DISPENSE_FAILURE)
        );
        //Set new vend status of each product.
        setProductDispenseStatuses(nextProductDispenseStatuses);
        setVendStatusCompleted(true);
        return setErrorOccured(true);
      }
    });
  };

  //Validate dispense call.
  useEffect(() => {
    if (dispenseProducts.length > 0) {
      clearCart();
      //Timestamp of dispenseTimeout in milliseconds
      // let dispenseTimeout =
      //   new Date().getTime() +
      //   convertSecondsToMilliseconds(
      //     vendingMachineDetails.configurations.dispense_timeout *
      //       dispenseProducts.length
      //   );

      //Adds dispense timeout to current time.
      // return startProductStatusPolling(dispenseTimeout);
      if (location.state?.data?.dispenseLater !== true) {
        requestPostFetchApi(API_KEYS.VALIDATE_DISPENSE, {
          cUID,
          time: new Date().getTime(),
          vmId: vendingMachineDetails.id,
          customer_id: getUserId(),
          phone_no: getUserPhone(),
          hash: getUserHashToken(),
        }).then(
          () => {
            //Timestamp of dispenseTimeout in milliseconds
            let dispenseTimeout =
              new Date().getTime() +
              convertSecondsToMilliseconds(
                vendingMachineDetails.configurations.dispense_timeout *
                  dispenseProducts.length
              );

            //Adds dispense timeout to current time.
            return startProductStatusPolling(dispenseTimeout);
          },
          () => {
            //error occured.
            return dispenseFailed();
          }
        );
      } else {
        let dispenseTimeout =
          new Date().getTime() +
          convertSecondsToMilliseconds(
            vendingMachineDetails.configurations.dispense_timeout *
              dispenseProducts.length
          );
        startProductStatusPolling(dispenseTimeout);
      }
    }
  }, []);

  const toggleFeedbackModal = function () {
    return setShowFeedbackModal(!showFeedbackModal);
  };

  //If no items in cart, redirect to homepage.
  if (dispenseProducts.length === 0) {
    history.push(APP_ROUTES.HOME_PAGE.url);
    return <React.Fragment></React.Fragment>;
  }
  // fetching unique dispense products from dispense products
  let temp = [],
    uniqueDispenseProducts = [];
  uniqueDispenseProducts = dispenseProducts.filter((element) => {
    if (!temp.includes(element.item.iUID)) {
      temp.push(element.item.iUID);
      return element;
    }
  });

  return (
    <React.Fragment>
      <Header className="vending-machine-dispense__header">
        <span className="vending-machine-dispense__pag-title">
          {componentTexts.dispense_page_title}
        </span>
        <span></span>
      </Header>
      <section className="vending-machine-dispense">
        {vendDispenseCompleted && !errorOccured ? (
          <h3 style={{ color: "orange" }}>Dispense successful !</h3>
        ) : (
          <ImageViewer
            className="vending-machine-dispense__image"
            src="/images/vending_dispense.png"
            alt="Vending machine dispensing items"
          />
        )}
        <div className="vending-machine-dispense__items">
          <h3 className="main-head">
            {vendDispenseCompleted && !errorOccured ? (
              <img
                src={clDetails.logo_without_slogan}
                style={{
                  width: "200px",
                  height: "100px",
                }}
              />
            ) : (
              componentTexts.dispense_page_dispensing_order_text
            )}
          </h3>

          <div className="vending-machine-dispense-grid">
            {uniqueDispenseProducts.map((element) => {
              return (
                <div
                  className="vending-machine-dispense__item outer-shadow"
                  key={element.item.sid}
                >
                  <ImageViewer
                    className="vending-machine-dispense__item-image"
                    src={element.item.img}
                    alt={element.item.name}
                  />
                  <span className="vending-machine-dispense__item-name">
                    <p className="vending-machine-dispense__item-name-ellipses ellipses">
                      {element.item.name}
                    </p>
                  </span>
                  <span className="vending-machine-dispense__item-status">
                    {productsDispenseStatuses[element.item.sid] ===
                      DISPENSE_WAITING && (
                      <ImageViewer
                        src={spinner}
                        alt="vendify-spinner"
                        className="vending-machine-dispense__item-status-loading"
                      />
                    )}
                    {productsDispenseStatuses[element.item.sid] ===
                      DISPENSE_SUCCESS && (
                      <i className="vending-machine-dispense__item-status-success">
                        <SuccessIcon />
                      </i>
                    )}

                    {![DISPENSE_WAITING, DISPENSE_SUCCESS].includes(
                      productsDispenseStatuses[element.item.sid]
                    ) && (
                      <i className="vending-machine-dispense__item-status-failed">
                        <CrossIcon />
                      </i>
                    )}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
        <span className="order-id__text">{`${componentTexts.order_id_text}: ${orderId}`}</span>
        {vendDispenseCompleted && !errorOccured && (
          <span className="dispense-success-mesg">{`Your Order has been dispensed successfully`}</span>
        )}

        {errorOccured && (
          <div className="vending-machine-dispense__failure">
            <h4 className="sub-head">
              {componentTexts.dispense_failed_screen.dispense_failed_title}
            </h4>
          </div>
        )}
        {vendDispenseCompleted && (
          <React.Fragment>
            <Button
              onClick={goToDashboard}
              className="vending-machine-dispense__dashboard-button"
            >
              {componentTexts.dispense_page_button_text}
            </Button>
            {/* <Button onClick={toggleFeedbackModal}>
              {componentTexts.dispense_page_feedback_button_text}
            </Button> */}
          </React.Fragment>
        )}
      </section>

      <OrderFeedback
        open={showFeedbackModal}
        componentTexts={componentTexts.feedback_modal}
        closeHandler={toggleFeedbackModal}
        orderId={orderId}
      />
    </React.Fragment>
  );
}

VendingMachineDispense.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
};

const mapStateToProps = (state) => ({
  clDetails: state.clDetailsReducer,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendingMachineDispense);
